import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";
import { HorarioService } from "service/HorarioService";

const horarioService = new HorarioService();

const ModalHorario = ({ isOpen, toggle, selectedHorario, onSave }) => {
  const [horario, setHorario] = useState({ denominacion: "", descripcion: "" });

  useEffect(() => {
    if (isOpen) {
      setHorario(selectedHorario ?? { denominacion: "", descripcion: "" });
    }
  }, [isOpen, selectedHorario]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHorario((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!horario.denominacion.trim()) {
      alert("El nombre es obligatorio");
      return;
    }
    try {
      const res = horario._id
        ? await horarioService.updateHorario(horario)
        : await horarioService.addHorario(horario);
      if (res?.confirmation === "success") {
        alert(horario._id ? "Horario actualizado" : "Horario registrado");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar");
      }
    } catch (error) {
      console.error("Error guardando horario:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {horario._id ? "Editar Horario" : "Nuevo Horario"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Denominación</Label>
            <Input
              name="denominacion"
              value={horario.denominacion}
              onChange={handleChange}
              placeholder="Nombre del horario"
            />
          </FormGroup>
          <FormGroup>
            <Label>Descripción</Label>
            <Input
              type="textarea"
              name="descripcion"
              value={horario.descripcion}
              onChange={handleChange}
              placeholder="Descripción del horario"
              rows="3"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalHorario;
